let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kDCdq")).then(() => parcelRequire('hq0Gw'));